import { CalendarWeek, ClockHistory, LockFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import BaseCard from '@/components/shared/BaseCard';
import { getCdnUrl } from '@/helpers';
import { enStatus, IMyCourse } from '@/interfaces/course';
import styled, { StyledProp } from '@/styled';

import MoreInfo from './MoreInfo';
import ShortInfo from './ShortInfo';

interface Props extends StyledProp, Partial<IMyCourse> {}

const MyCoursesCard = ({ className, ...props }: Props) => {
  const navigate = useNavigate();

  const { image, old_image, course_newcard_background, hash = '' } = props;
  const currentImage = getCdnUrl(course_newcard_background, image, old_image);

  const iconMapper: Record<string, any> = {
    [enStatus.EXPIRED]: <ClockHistory size={48} />,
    [enStatus.BLOCKED]: <LockFill size={48} />,
    [enStatus.NOT_RELEASED]: <CalendarWeek size={48} />,
    [enStatus.NOT_PURCHASED]: <LockFill size={48} />
  };

  return (
    <div className={className}>
      <BaseCard
        image={{ aspect: '16:9', src: currentImage }}
        onClick={() => navigate(`/curso/${hash}`)}
        internalSpace={16}
        extraContent={<div className='status'>{iconMapper[props.status]}</div>}
      >
        <ShortInfo course={props} showStatus />
      </BaseCard>

      <MoreInfo course={props} className='moreInfo'>
        <ShortInfo course={props} />
      </MoreInfo>
    </div>
  );
};

export default styled(MyCoursesCard)`
  overflow: visible !important;

  .base-card {
    border: 1px solid transparent;
    border-bottom: 0;
    border-top-right-radius: ${({ theme }) => theme.borderRadius}px;
    border-top-left-radius: ${({ theme }) => theme.borderRadius}px;
    transition: border-color 300ms;
  }

  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: calc(100% - 105px);
    top: 0px;
    left: 0;
    z-index: 2;

    svg {
      color: ${({ theme }) => theme.colorIcon};
      filter: drop-shadow(0px 0px 16px rgb(0 0 0 / 1));
    }
  }

  &:hover {
    .base-card {
      border-color: ${({ theme }) => theme.colorPrimary};
    }

    .moreInfo {
      opacity: 1;
      pointer-events: all;
      border-color: ${({ theme }) => theme.colorPrimary};
    }
  }
`;
